export const getClientIanaTimezone = (): string | undefined => {
  if (typeof globalThis.window === 'undefined') {
    return undefined;
  }

  if (Intl === undefined || Intl.DateTimeFormat === undefined) {
    return undefined;
  }

  try {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    return timeZone;
  } catch (error) {
    console.error('Failed to detect client IANA timezone:', error);
    return undefined;
  }
};
